import { render, staticRenderFns } from "./KGFBAjanlatBase.vue?vue&type=template&id=cfe47064&"
import script from "./KGFBAjanlatBase.vue?vue&type=script&lang=js&"
export * from "./KGFBAjanlatBase.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports